import { CategoryLabel, ThemeLabel } from '@bnnvara/labels';
import PropTypes from 'prop-types';
import React from 'react';

export const CardLabel = ({
  categories,
  brand,
  subTheme,
  variant,
  overRide,
}) => {
  const category = categories?.length > 0 ? categories[0].name : undefined;
  // Check if should render
  if (!brand) {
    return null;
  }
  if (category && overRide !== 'theme') {
    if (
      (brand.prioItemLabel === undefined && !subTheme) ||
      brand.prioItemLabel === 'category' ||
      overRide === 'category'
    ) {
      return (
        <CategoryLabel variant={variant} color="primary">
          {category}
        </CategoryLabel>
      );
    }
  }
  if (subTheme && overRide !== 'category') {
    if (
      brand.prioItemLabel === undefined ||
      brand.prioItemLabel === 'theme' ||
      overRide === 'theme'
    ) {
      return (
        <ThemeLabel variant={variant} color={subTheme?.color}>
          {subTheme.name}
        </ThemeLabel>
      );
    }
  }
  return null;
};

CardLabel.defaultProps = {
  brand: null,
  categories: null,
  subTheme: null,
  variant: 'articleCard',
  overRide: null,
};

CardLabel.propTypes = {
  brand: PropTypes.shape({
    name: PropTypes.string,
    prioItemLabel: PropTypes.string,
  }),
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  subTheme: PropTypes.shape({
    id: PropTypes.string,
    slug: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string,
    colorHover: PropTypes.string,
    colorActive: PropTypes.string,
    colorVisited: PropTypes.string,
  }),
  variant: PropTypes.oneOf(['articleCard', 'mediaCard']),
  overRide: PropTypes.oneOf([null, 'category', 'theme']),
};

export default CardLabel;
